
  import { css } from 'lit';
  export const styles = css`:host{--background: var(--ig-tooltip-background, hsl(from var(--ig-gray-900) h s l/0.8));--text-color: var(--ig-tooltip-text-color, var(--ig-gray-900-contrast));--border-radius: var(--ig-tooltip-border-radius, clamp(0rem, calc(var(--ig-radius-factor, 0.125) * 1rem), 1rem));--ig-theme: fluent;--ig-theme-variant: light}`;
  